var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, Renderer2 } from '@angular/core';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { ProjectService } from '../../../services/project/project.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
var ProjectSelectionComponent = /** @class */ (function (_super) {
    __extends(ProjectSelectionComponent, _super);
    function ProjectSelectionComponent(modalService, projectService, renderer, validationHandlerService, deviceDetector) {
        var _this = _super.call(this, validationHandlerService, deviceDetector, renderer) || this;
        _this.modalService = modalService;
        _this.projectService = projectService;
        _this.renderer = renderer;
        _this.validationHandlerService = validationHandlerService;
        _this.deviceDetector = deviceDetector;
        _this.allowToModifyProject = true;
        _this.afterDeleteProjectEvent = new EventEmitter();
        _this.editProjectEvent = new EventEmitter();
        return _this;
    }
    ProjectSelectionComponent.prototype.onSelectProject = function (evt) {
        if (evt.id > 0) {
            _super.prototype.onSelect.call(this, evt);
        }
    };
    ProjectSelectionComponent.prototype.onShowDeleteWarningPopup = function (evt, project) {
        evt.stopPropagation();
        this.selectedProject = project;
        this.modalService.openInCenter(this.deleteProjectWarning);
        this.ngSelect.close();
    };
    ProjectSelectionComponent.prototype.onClickProjectOption = function (evt, project) {
        if (project.id === 0) {
            evt.stopPropagation();
            this.editProjectEvent.emit({ id: project.id, countries: [] });
            this.ngSelect.close();
        }
    };
    ProjectSelectionComponent.prototype.onEditProject = function (evt) {
        this.editProjectEvent.emit(evt);
    };
    ProjectSelectionComponent.prototype.executeDeleteProject = function (e) {
        var _this = this;
        if (this.selectedProject) {
            this.modalService.close();
            this.projectService.deleteProject(this.selectedProject.id).subscribe(function (res) {
                _this.afterDeleteProjectEvent.emit(_this.selectedProject.id);
                _this.hideDeletePopup();
            });
        }
    };
    ProjectSelectionComponent.prototype.beforeDismissDeleteProjectPopup = function () {
        this.selectedProject = undefined;
    };
    ProjectSelectionComponent.prototype.hideDeletePopup = function () {
        this.beforeDismissDeleteProjectPopup();
        this.modalService.close();
    };
    ProjectSelectionComponent.prototype.getDeleteProjectName = function () {
        return this.selectedProject ? this.selectedProject.name : '';
    };
    ProjectSelectionComponent.prototype.getProjectActionDataByContext = function (isNewProject, isDeleted) {
        if (isNewProject) {
            return Object.assign({}, this.actionData, {
                params: {
                    action: UserActionType.CREATE
                }
            });
        }
        else if (isDeleted) {
            return Object.assign({}, this.actionData, {
                params: {
                    action: UserActionType.DELETE
                }
            });
        }
        return this.actionData;
    };
    ProjectSelectionComponent.prototype.onMouseOver = function () {
        if (!this.tooltipBox) {
            return;
        }
        this.tooltipBox.disableTooltip = this.ngSelect.isOpen;
    };
    return ProjectSelectionComponent;
}(AchooFilterBoxComponent));
export { ProjectSelectionComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/project-selection/project-selection.component.ts.pre-build-optimizer.js